module.exports = __webpack_public_path__ + "img/tu_6.78a43c41.png";